import type { JSX } from 'react';
import { SectionHeader } from '@ksyos/design-system';
import { useState } from 'react';
import type { ServiceOrganizationRole as Role } from '@common/enums';
import { ServiceOrganizationRoles } from '@frontend/components/pages/organizations/serviceOrganizationRoles/ServiceOrganizationRoles';
import { ServiceOrganizationRole } from '@frontend/components/pages/organizations/serviceOrganizationRoles/ServiceOrganizationSettingRole';
import { getSelectedLanguage } from '@frontend/translate';
import { useServiceOrganizationSettingContext } from '@frontend/utils/hooks/useServiceOrganizationsSettingsContext';
import { ServiceOrganizationSettingStatus } from './ServiceOrganizationSettingStatus';

type ServiceOrganizationProps = {
    serviceOrganizationRoles: Role[];
};

export function ServiceOrganizationSettings(props: ServiceOrganizationProps): JSX.Element {
    const { serviceOrganizationRoles } = props;
    const { serviceOrganizationSetting } = useServiceOrganizationSettingContext();
    const [selectedRoles, setSelectedRoles] = useState<Role[]>([]);
    const languageFile = getSelectedLanguage();

    return (
        <>
            <SectionHeader title={`${languageFile.common.settings} ${serviceOrganizationSetting.service.name}`} />
            <ServiceOrganizationSettingStatus />
            <ServiceOrganizationRoles
                onChange={handleChangeRoles}
                roles={serviceOrganizationRoles}
            />
            {selectedRoles.map((role) => (
                <ServiceOrganizationRole
                    key={role}
                    role={role}
                    serviceCode={serviceOrganizationSetting.service.code}
                />
            ))}
        </>
    );

    function handleChangeRoles(roles: Role[]): void {
        setSelectedRoles(roles);
    }
}
